// src/components/ShareButton.js
import React, { useState } from 'react';
import ShareIcon from './icons/ShareIcon';

const ShareButton = ({ url }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const copyToClipboard = () => {
    const urlToCopy = url || window.location.href;

    const textArea = document.createElement('textarea');
    textArea.value = urlToCopy;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    } finally {
      document.body.removeChild(textArea);
    }
  };

  return (
    <button onClick={copyToClipboard} className="share-button" title="Copy Link">
      {showSuccess && <div className="share-success">Link Copied!</div>}
      <ShareIcon />
    </button>
  );
};

export default ShareButton;